import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IUserActionResult } from '../types/IUserActionResult';

export interface IImportExternalSiteUsersParams {
  emailAddresses: string[];
  siteRole: string; //SiteRoles
  authSetting: string;
}

export class ImportExternalSiteUsersRequest extends Request<IImportExternalSiteUsersParams, IUserActionResult> {
  constructor(params: IImportExternalSiteUsersParams) {
    super('importExternalUsers', params);
  }
}
